import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RootPage } from './root';
import {HeaderTitleComponentModule} from "../../components/header-title/header-title.module";

@NgModule({
  declarations: [
    RootPage,
  ],
  imports: [
    IonicPageModule.forChild(RootPage),
    HeaderTitleComponentModule
  ],
})
export class RootPageModule {}



// WEBPACK FOOTER //
// ./src/pages/root/root.module.ts